<mat-card class="cardWithShadow">
  <mat-card-content class="p-5">
    <div class="row">
      <div class="col-md-4 d-flex">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>Buscar</mat-label>
          <input
            matInput
            placeholder="Buscar"
            [(ngModel)]="filterValue"
            toUppercase
            (keyup)="applyFilter()"
          />
          <mat-icon matPrefix class="op-5">search</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-md-2 d-flex">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>Filtro columna</mat-label>
          <mat-select placeholder="Filtro columna" id="selectedColumn" name="selectedColumn" [(ngModel)]="selectedColumn" (selectionChange)="applyFilter()">
            <mat-option value="todas">TODAS</mat-option>
            <mat-option *ngFor="let filtro of filtros" value="{{filtro.value}}">
                {{filtro.text}}
            </mat-option>
          </mat-select>
          <mat-icon matPrefix class="op-5">filter_list</mat-icon>
        </mat-form-field>
      </div>

      <div class="col-md-2 d-flex">
        <button mat-flat-button (click)="exportToExcel()" color="primary" class="w-100">
          <mat-icon matPrefix class="op-5">import_export</mat-icon>
          Exportar</button>
      </div>
      
      <div *ngIf="!this.toolsService.userInRol(['ADMINISTRADOR'])" class="col-md-2 d-flex"></div>
        
      <div *ngIf="this.toolsService.userInRol(['ADMINISTRADOR'])" class="col-md-2 d-flex">
        <button mat-flat-button (click)="openDialogCarga()" color="primary" class="w-100">
          <mat-icon matPrefix class="op-5">cloud_upload</mat-icon>
          Carga masiva</button>
      </div>
      
      <div class="col-md-2 d-flex">
        <button mat-flat-button (click)="openDialog('Guardar', {})"  color="accent" class="w-100">
          <mat-icon matPrefix class="op-5">library_add</mat-icon>
          Crear Usuario
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="cardWithShadow">
  <mat-card-content class="p-5">
    <div class="table-responsive">
      <table mat-table [dataSource]="dataUsuarios" class="w-100"  matSort #sort="matSort" (matSortChange)="announceSortChange($event)">
        <ng-container matColumnDef="run">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >Run</th>
          <td mat-cell *matCellDef="let element">{{ element.rundv }}</td>
        </ng-container>

        <ng-container matColumnDef="nombres">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >Nombres</th>
          <td mat-cell *matCellDef="let element">{{ element.nombres }}</td>
        </ng-container>

        <ng-container matColumnDef="apellidoPaterno">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >1er Apellido</th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.apellidoPaterno }}</td>
        </ng-container>

        <ng-container matColumnDef="apellidoMaterno">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >2do Apellido</th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.apellidoMaterno }}</td>
        </ng-container>

        <ng-container matColumnDef="correoCorporativo">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >Correo Corporativo</th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.correoCorporativo }}</td>
        </ng-container>

        <ng-container matColumnDef="direccionRegional">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >Dirección Regional</th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.direccionRegional }}</td>
        </ng-container>

        <ng-container matColumnDef="nombrePerfil">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >Perfil</th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.nombrePerfil }}</td>
        </ng-container>

        <ng-container matColumnDef="oficina">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" mat-sort-header >Unidad/Jardín</th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.unidad }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Acciones</th>
          <td mat-cell *matCellDef="let element" class="action-link">
            <mat-icon 
						#tooltip="matTooltip"
						matTooltip= "Editar usuario"
						matTooltipPosition="above"
						(click)="openDialog('Actualizar', element)" 
						color="primary" 
						matPrefix 
						class="m-r-10 cursor-pointer">edit</mat-icon>

            <mat-slide-toggle [(ngModel)]="element.estadoUsuBool"
              style="display: inline-flex;"
              id="estadoUsuBool"
              name="estadoUsuBool"
              #tooltip="matTooltip"
              matTooltip= "{{element.estadoUsuBool? 'Desactivar' : 'Activar'}}"
              matTooltipPosition="above"
              class="m-r-10 cursor-pointer"
              checked="{{element.estadoUsuBool}}"
              (click)="setEstadoUsuario(element)">
            </mat-slide-toggle>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 15, 20, 25]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>